<template>
    <h1>App</h1>
</template>

<script>

export default {
  name: 'App',
  components: {
    
  },
  data() {
    return {
      campaign: this.$route.fullPath
    }
  },
  mounted() {
    console.log("mounted");
    console.log(this.campaign);
  },
  methods: {

  },
  setup() {
    console.log("setup");
  }
}



</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
